import { TProductVariant } from 'pages/saved-project-configuration/types';

export const getVariantText = (variant: TProductVariant): string => {
  const { price, quantity, onePiece } = variant;
  const totalPrice = price * quantity;

  if (onePiece) {
    return `${quantity} шт. x ${onePiece} = ${totalPrice} ₽`;
  }

  return `${quantity} шт. = ${totalPrice} ₽`;
};
